import Header from "../pages/Header";
import Footer from "./Footer";
import styles from "../pages/Contact.module.css";
import Config from "../pages/Config";

function Contact () {
  return(
    <>
    <Header />
    <div className={styles.fullWrapper}>
      <div className={styles.container}>
        <h1>Contact Us</h1>

        <p>
        Need help with your order or have a question?<br/>
        Our support team is available on WhatsApp.
        </p>

        <a 
        className={styles.whatsappBtn}
        href={`https://wa.me/91${Config.whatsAppNumber}?text=Hello%20I%20need%20help%20with%20my%20order`}
        target="_blank" rel="noreferrer"
        >
        Chat on WhatsApp
        </a>

        <p className={styles.note}>
        We usually reply within a few minutes during business hours.
        </p>
        
        <a className={styles.returnLink} href="/" title="Continue shopping">
        Back to shopping</a>
      </div>
    </div>
    <Footer />
    </>
    );
}
export default Contact;